/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';

.row.signature {
  justify-content: flex-end;
  align-items: center;
  margin-top: 12px;
  color: variables.$text-color-black-medium-emphasis;
}
